<template>
  <div class="fill-height">
    <FufuHeader :shop="shop"> {{ firstVisitor ? '初回' : '' }}予約 </FufuHeader>
    <v-container class="white" fill-height>
      <v-layout column>
        <v-layout justify-center class="body-1 fufugrey2--text">
          <span v-if="menu"> {{ menu.displayName || menu.name }} </span>
          <span v-if="menu && menu.color">
            &nbsp; / {{ menu.color.displayName }}
          </span>
          <span v-if="menuOption">
            &nbsp; / {{ menuOption.displayName || menuOption.name }}
          </span>
        </v-layout>
        <v-layout>
          <v-flex xs4>
            <v-btn
              :to="{
                name: 'TreatmentSelection',
                params: { shopId, menuId },
                query: {
                  first: firstVisitor,
                },
              }"
              text
              exact
              color="primary"
              replace
            >
              <v-icon>mdi-chevron-right</v-icon>
              前の画面へ戻る
            </v-btn>
          </v-flex>
          <v-flex xs4 class="text-center">
            頭皮ケアを選択してください。
          </v-flex>
        </v-layout>

        <v-layout>
          <v-flex xs12>
            <v-card tile flat>
              <div>
                <v-row>
                  <v-col
                    v-for="opt in scalpCares.filter(x => x.visibleForCustomer)"
                    :key="opt.id"
                    cols="6"
                  >
                    <v-card
                      class="fill-height white--text"
                      flat
                      color="fufugrey2"
                      @click="goNext(opt.id)"
                    >
                      <v-layout
                        column
                        justify-center
                        align-center
                        class="pa-5 font-weight-bold"
                      >
                        <b class="fufuyellow--text text-h6 font-weight-bold">{{
                          getName(opt)
                        }}</b>

                        <span>
                          {{ priceFormat(getPrice(opt)) }}円
                          <small
                            v-if="
                              firstVisitor &&
                                getPrice(opt) !== Number(opt.priceWithTax || 0)
                            "
                          >
                            （通常{{ priceFormat(opt.priceWithTax) }}円）
                          </small>
                        </span>
                      </v-layout>
                    </v-card>
                  </v-col>
                  <v-col cols="12">
                    <v-card
                      flat
                      color="fufugrey2"
                      class="white--text"
                      @click="goNext(null)"
                    >
                      <v-layout
                        column
                        justify-center
                        align-center
                        class="pa-5 body-1"
                      >
                        <b>頭皮ケアなし</b>
                      </v-layout>
                    </v-card>
                  </v-col>
                </v-row>
              </div>
            </v-card>
          </v-flex>
        </v-layout>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import moment from 'moment'
import { api } from '@/api'
import FufuHeader from '@/components/FufuHeader'

function fetchData(shopId, menuId, menuOptId) {
  const reqs = [
    api.shops(shopId).get(),
    api
      .shops(shopId)
      .menus(menuId)
      .get(),
    api
      .shops(shopId)
      .scalpCares()
      .all(),
  ]
  if (menuOptId) {
    reqs.push(
      api
        .shops(shopId)
        .menuOptions(menuOptId)
        .get()
    )
  }

  return Promise.all(reqs)
}

export default {
  name: 'ScalpCareSelection',
  components: {
    FufuHeader,
  },
  props: {
    shopId: {
      type: String,
      required: true,
    },
    menuId: {
      type: [String, Number],
      default: '',
    },
    firstVisitor: {
      type: Boolean,
      default: false,
    },
    mode: {
      type: Number,
      default: 1,
    },
  },
  data: () => ({
    shop: null,
    menu: null,
    menuOption: null,
    scalpCares: [],
    next: null,
    selected: 0,
  }),
  computed: {
    specialPrice() {
      return this.mode === 2 && this.firstVisitor
    },
  },
  methods: {
    enableOption(optId) {
      let menu = this.menu
      if (!menu) return false
      return menu.options.includes(optId)
    },

    getNextDate() {
      let now = moment()

      if (this.mode === 2) {
        if (this.shop.startAt) {
          const start = moment(this.shop.startAt)
          if (start.isAfter(now)) {
            const diff = start.diff(now, 'days')
            if (diff > 0) {
              return now.add(diff + 3, 'days').format('YYYY-MM-DD')
            }
          }
        }
        return now.add(2, 'days').format('YYYY-MM-DD')
      } else {
        return now.add(23, 'days').format('YYYY-MM-DD')
      }
    },

    goNext(optId) {
      const date = this.getNextDate()

      this.$router.replace({
        name: 'TimeSelection',
        params: {
          shopId: this.shopId,
          menuId: this.menuId,
          date: date,
        },
        query: {
          first: this.firstVisitor,
          scalpCare: optId,
          menuOption: this.menuOption ? this.menuOption.id : null,
        },
      })
    },

    priceFormat(x) {
      return Number(x).toLocaleString()
    },

    getName(opt) {
      return opt.displayName || opt.name
    },

    getPrice(opt) {
      if (this.specialPrice) {
        return opt.firstPriceWithTax
      }
      const price = opt.priceWithTax
      return Number(price)
    },
  },
  async beforeRouteEnter(to, from, next) {
    const shopId = to.params.shopId
    const menuId = to.params.menuId
    const menuOptId = to.query.menuOption
    try {
      const [shop, menu, scalpCares, menuOption] = await fetchData(
        shopId,
        menuId,
        menuOptId
      )
      next(vm => {
        vm.shop = shop
        vm.menu = menu
        vm.menuOption = menuOption
        vm.scalpCares = scalpCares
      })
    } catch (err) {
      next(err)
    }
  },
  async beforeRouteUpdate(to, from, next) {
    const shopId = to.params.shopId
    const menuId = to.params.menuId
    const menuOptId = to.query.menuOption
    try {
      const [shop, menu, scalpCares, menuOption] = await fetchData(
        shopId,
        menuId,
        menuOptId
      )
      next(vm => {
        vm.shop = shop
        vm.menu = menu
        vm.menuOption = menuOption
        vm.scalpCares = scalpCares
      })
    } catch (err) {
      next(err)
    }
  },
}
</script>
